import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const HeartIcon = ({tintColor = '#C900E0', ...props}) => {
  return (
    <Svg
      width={18}
      height={15}
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.25 5.03C.25 2.33 2.62.25 5.4.25 6.833.25 8.095.922 9 1.792 9.905.922 11.166.25 12.6.25c2.78 0 5.15 2.08 5.15 4.78 0 1.85-.789 3.476-1.882 4.852-1.09 1.372-2.518 2.537-3.885 3.484-.522.362-1.05.695-1.533.941-.453.231-.975.443-1.45.443s-.997-.212-1.45-.443a13.79 13.79 0 01-1.533-.941c-1.367-.947-2.794-2.112-3.885-3.484C1.039 8.506.25 6.88.25 5.03zM5.4 1.75c-2.08 0-3.65 1.53-3.65 3.28 0 1.403.596 2.71 1.556 3.918.962 1.21 2.257 2.279 3.565 3.185.495.343.96.635 1.36.838.428.218.676.279.769.279.093 0 .341-.061.77-.28.398-.203.864-.494 1.36-.837 1.307-.906 2.602-1.974 3.564-3.185.96-1.208 1.556-2.515 1.556-3.918 0-1.75-1.57-3.28-3.65-3.28-1.194 0-2.31.713-3.005 1.619a.75.75 0 01-1.19 0C7.71 2.463 6.595 1.75 5.4 1.75z"
        fill={tintColor}
      />
    </Svg>
  );
};

export default HeartIcon;
